<template>
    <div class="search-condition-text">
        <label v-if="typeof labelText !== 'undefined'">{{labelText}}<span v-if="required" style="color:#FC1111;">*</span></label>
        <input :type="type?type:'text'" name="" :value="value" :maxlength="maxLength" :placeholder="placeholder"
               v-on:change="onChangeEvent($event)" :disabled="disabled"
               @input="onChangeEvent($event)"
               @blur="onBlurEvent($event)"
               :style="inputStyle"
        />
    </div>
</template>

<script>
    export default {
        name: "BTextInput",
        props: {
            labelText: String,
            placeholder: String,
            value: String,
            type: String,
            maxLength: Number,
            required: Boolean,
            disabled: Boolean,
            inputLength: Number,
        },
        computed: {
            inputStyle() {
                let length = 215;
                if (typeof this.inputLength !== "undefined") {
                    length = this.inputLength;
                }
                return {
                    '--input-width': length + "px"
                }
            }
        },
        methods: {
            onChangeEvent(event) {
                this.$emit("changed", event.target.value);
                this.$emit("input", event.target.value);
            },
            onBlurEvent(event) {
                this.$emit("blur", event.target.value);
            }
        }
    }
</script>

<style scoped>
    .search-condition-text {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
    }

    .search-condition-text label {
        color: #333333;
        width: 66px;
        text-align: right;
        margin: 0 10px 0 20px;
    }

    .search-condition-text input {
        width: var(--input-width);
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #DEE2E6;
        border-radius: 5px;
        padding-left: 8px;
        padding-right: 8px;
        margin: 1em 0;
        font-size: 14px;
        font-family: inherit;
    }

    input:focus {
        border: 1px solid #0171A3;;
    }

    * {
        outline: none;
    }
</style>